/* ============================================================
   第一關的 BOSS 時刻表（使用者 2026-08-03 拍板）
   ============================================================

   原型有 23 隻，**造型全部移植進來了**（`entities/bosses/`），
   但第一關只上四隻 + 一個待定的最終 Boss。這張表是唯一的名單來源：

   - 圖鑑的**玩家模式**只列這張表上的 Boss（開發模式看得到 23 隻全部）
   - `sim/stage-flow.ts` 的降臨時刻讀這張表

   ## 為什麼是這四隻

   **四隻剛好四個威脅色一色一隻** —— 跟小怪名冊「每一段四色到齊」是同一條
   紀律，四場 Boss 戰不會有兩場在教同一種威脅。

   | 時間 | Boss | 色 | 這一場教什麼 |
   |---|---|---|---|
   | 5:00 | WALZE 軋輥 | 紅 | 打亮的地方（可破壞：左前腿＋砲塔核心） |
   | 9:00 | ZENIT 天頂 | 紫 | 同一條規則再教一次（可破壞：兩具砲莢） |
   | 13:00 | MUTTER 母體 | 天藍 | 先解決來源 |
   | 16:00 | KATHEDRALE 大聖堂 | 橙 | 你躲的掩體會消失 |

   ⚠️ **MUTTER 排在 13:00 而不是 16:00 是有理由的**：牠會生小怪，而第 16–17
   分鐘的同屏峰值是 387 隻 —— 生三隻在那裡沒有人看得出來。13:00 約 200 隻，
   牠的機制才讀得到。順帶尺寸也變成單調遞增（3.3 → 4.6 → 7.6 → 9.0）。

   ## 18:30 · KAISER 皇帝（使用者 2026-08-03 拍板的最終 Boss）

   | 18:30 | KAISER 皇帝 | 橙 | 三階段，一階段一種打法 |

   **三階段是它被選上的理由**：前四隻都是兩階段，最終戰要有第三段才讀得出
   「這一場不一樣」。而且那三段各自換了一種戰鬥形態 ——
   立姿砲擊 → 甩甲跪地變固定砲台 → 上半身脫離浮空，
   走位壓力來源從「繞著打」變成「打定點」再變成「追著跑」。

   ⚠️ 橙色與 KATHEDRALE 重複，四色一色一隻那條紀律在第五隻上刻意破例 ——
   最終 Boss 是**回收**（玩家已經學會的四種威脅一次全上），不是教新東西。
   五隻的威脅色集合仍然涵蓋四色（`codex.test.ts` 守這一條）。 */

/** 第一關的降臨時刻表。`at` 是對局秒數。

    ⚠️ **KAISER 是最終 Boss，牠在 `RUN_LEN`（20:00）整降臨，而且
    「打倒牠」才是通關條件**（2026-08-06 使用者拍板，在那之前是
    「撐到 20 分鐘」就贏，KAISER 排在 18:30 只是一隻比較硬的路障）。

    所以 20:00 不再是終點而是**最後一場考試的開始**：
    時鐘照走，玩家要在已經爆表的同屏數裡把牠打下來。
    這也是難度階梯（`data/pacing.ts`）最後那一段壓力期存在的理由。 */
export var BOSS_ROSTER = [
  { id: 'walze', at: 300 },
  { id: 'zenit', at: 540 },
  { id: 'mutter', at: 780 },
  { id: 'kathedrale', at: 960 },
  { id: 'kaiser', at: 1200 }
];

/** 最終 Boss 的 id。打倒牠＝通關（`sim/stage-flow.ts` 的 `onBossKilled`）。
    **用名冊的最後一筆而不是寫死字串** —— 之後換關卡、換 Boss 順序時，
    寫死的那個字串會靜靜地讓「通關」變成永遠不會發生的事。 */
export var FINAL_BOSS_ID = BOSS_ROSTER[BOSS_ROSTER.length - 1].id;

/** 這一關會遇到的 Boss id（圖鑑的玩家模式用它過濾）。 */
export var ROSTER_IDS = BOSS_ROSTER.map(function (b) { return b.id; });
